var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"crud"}},[_c('iframe',{attrs:{"src":_vm.$store.state.api_url+'/crud/'+_vm.$route.meta.crud+'?key='+_vm.key}})])
}
var staticRenderFns = []

export { render, staticRenderFns }